export function slugify(text: string): string {
  const slug = text.trim().toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "")
  return /^[0-9]/.test(slug) ? `_${slug}` : slug || "item"
}

export function capitalize(text: string) {
  return text.charAt(0).toUpperCase() + text.slice(1)
}

export function flowTitle(flows: Playbook["flows"], flow: string) {
  return flows[flow]?.title || capitalize(flow)
}
